function checkIsAddedToWishlist(type = 'product', target = null) {
	if (jQuery('.iwishAddWrap').length > 0) {
		jQuery('.iwishAddWrap').each(function () {
			if (type === 'product') {
				var iWishvId = null;
				if (jQuery(this).find('.iWishAdd').data('variant')) {
					iWishvId = `${jQuery(this).find('.iWishAdd').data('variant')}`;
				} else {
					iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
				}
				var iWishpId = jQuery(this).find('.iWishAdd').data('product');
				if (isInWishlist(iWishpId, iWishvId)) {
					jQuery(this).find('.iWishAdd').css('display', 'none').removeClass('iwishAdded');
					jQuery(this).find('.iWishRemove').css('display', 'block');
				} else {
					if (jQuery(this).attr('bookmark')) {
						jQuery(this).find('.iWishAdd').css('display', 'block').removeClass('iwishAdded');
					} else {
						jQuery(this).find('.iWishAdd').css('display', 'block').removeClass('iwishAdded').html('Save');
					}
					jQuery(this).find('.iWishRemove').css('display', 'none');
				}
			} else if (type === 'column') {
				var iWishvId = `${jQuery(this).data('variant')}`;
				var iWishpId = jQuery(target).data('product');
				if (isInWishlist(iWishpId, iWishvId)) {
					jQuery('.iWishAdd').css('display', 'none').removeClass('iwishAdded');
					jQuery('.iWishRemove').css('display', 'block');
				} else {
					jQuery('.iWishAdd').css('display', 'block').removeClass('iwishAdded');
					jQuery('.iWishRemove').css('display', 'none');
				}
			}
		});
	}
}
jQuery(document).ready(function () {
	checkIsAddedToWishlist();

	jQuery("a[href='/apps/iwish']").click(function (e) {
		if (typeof Storage !== 'undefined') {
			e.preventDefault();
			iWishPost('/apps/iwish', { iwishlist: JSON.stringify(iWishlistmain), cId: iwish_cid });
		}
	});

	jQuery('body').on('click', '.iWishAdd', function () {
		var iWishvId = null;
		if (jQuery(this).data('variant')) {
			iWishvId = `${jQuery(this).data('variant')}`;
		} else {
			iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
		}
		iwish_add(jQuery(this), iWishvId);
		checkIsAddedToWishlist('product', jQuery(this));
		window.openMyFavoritesPopUp();

		return false;
	});
	jQuery('body').on('click', '.iWishRemove', function () {
		var iWishvId = null;
		if (jQuery(this).data('variant')) {
			iWishvId = `${jQuery(this).data('variant')}`;
		} else {
			iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
		}
		// var iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
		iwish_remove(jQuery(this), iWishvId);
		checkIsAddedToWishlist('product', jQuery(this));
		window.handleWishlistCount('remove');
		return false;
	});

	// jQuery('.iWishAddColl').click(function () {
	//   var iWishvId = jQuery(this).attr('data-variant');
	//   iwish_addCollection(jQuery(this), iWishvId);
	//   return false;
	// });

	iwishCheckColl();

	jQuery('.iwish-product-form').each(function (i, e) {
		var quantity = jQuery(e).find('[name=quantity]').val();
		if (quantity < 1) {
			jQuery(e).find('[js-ajax-cart=addToCart] span').html(theme.strings.soldOut);
		}
	});

	var iWishCount = document.querySelector('.iWishCount');
	if (iWishCount) {
		var observer = new MutationObserver(showWishlistCount);
		var config = { childList: true };
		observer.observe(iWishCount, config);

		showWishlistCount();
	}
});

function showWishlistCount() {
	// if (iWishCnt > 0) {
	//   jQuery('.iWishCount').removeClass('is-hidden');
	// } else {
	//   jQuery('.iWishCount').addClass('is-hidden');
	// }
}

function iwishCheckColl() {
	if (jQuery('.iwishcheck').length > 0) {
		jQuery('.iwishcheck').each(function () {
			var iWishvId = jQuery(this).attr('data-variant');
			var iWishpId = jQuery(this).attr('data-product');
			if (isInWishlist(iWishpId, iWishvId)) {
				jQuery(this).addClass('iwishAdded').html(iwish_added_txt_col);
			}
			jQuery(this).removeClass('iwishcheck');
		});
	}
}